import { useState, useCallback } from 'react'

const useClientRect = () => {
  const [rect, setRect] = useState<DOMRect | null>(null)
  const ref = useCallback(node => {
    if (node !== null) {
      setRect(node.getBoundingClientRect())
    }
  }, [])
  return [rect, ref] as const
}

export default useClientRect
